import { Currency } from '../interfaces/onlineTraining';
import { configs } from '@pec/aion-ui-i18next/constants';

export const formatPrice = (total: number, location: string) => {
  return new Intl.NumberFormat(location, {
    style: 'currency',
    currency: Currency[location] || configs.currency.currency
  }).format(total);
};
